import React, {useState} from 'react';
import {
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faTrashAlt, // Added faTrashAlt
  faEllipsisH // Added faEllipsisH
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Removed Ant Design imports
// Removed Text, Title imports
import { API } from 'aws-amplify';
// Added CB component imports<
// Import all CB components from the barrel file
import { CBButton, CBCard, CBModal, CBDropdown, CBMenu, CBMenuItem } from '../../core/components/cbd';
import { CBProgress } from '../../core/components/CBProgress';

import { useGlobalState } from '../../../store';
import {
  colorNegative,
  colorNeutralDark,
  colorPositive
} from '../../../utils/colors';
import { accountIconMap } from '../../../utils/customIcons';
import { syncTypeText } from '../../../utils/words';
import ColorPicker from '../../syncs/components/ColorPicker';
// const syncStatusMap = {
//   synced: colorNeutral,
//   syncing: colorPositive,
//   synced_error: colorNegative,
//   deleting: colorNegative,
// }

const syncStatusMap = {
  synced: 'normal',
  syncing: 'normal',
  sync_conflict: 'exception',
  sync_conflict_onecal: 'exception',
  synced_error: 'exception',
  deleting: 'exception',
}

const SyncItem = ({ item, sourceAccountName,destAccountName,preview = false }) => {
  const [license] = useGlobalState('license')
  // State for confirmation modals
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showForceDeleteModal, setShowForceDeleteModal] = useState(false);


  function resolveError() {
    var str = item.errorState
    if(str.includes("Auth token refresh failed for")) {
      //re-authenticate account with link
      var accountId = str.substring(str.indexOf("for ")+4)
      return (<div><a href={`/dashboard/accounts/${accountId}`}
        >Account Issue please Re-Authenticate {accountId}</a></div>)
    } else if(item.status == "sync_conflict"){
      return (<div>Jerk Detected: reclaim or clockwise expand to find out</div>
        )
    } else if(item.status == "sync_conflict_onecal"){
      return (<div>Albanian malware detected</div>
        )
    }else if(str != ""){
      return (<div>Error: {str}</div>
        )
    } else {
      return <div>deleting...</div>
    }
  }

  // Handlers for modal actions
  const handleDeleteConfirm = async () => {
    setShowDeleteModal(false);
    try {
      await API.del('bridge', '/bridge', {
        body: {
          sourceCalendarId: item.sourceCalendarId,
          destCalendarId: item.destCalendarId,
        },
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'dashboardEvent',
        category: 'userActivity',
        action: 'deleteSync',
        label: license.userId,
        email: license.email
      });
      window.location.reload(); // Consider updating state instead of reload if possible
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Failed to delete sync."); // Simple error feedback
    }
  };

  const handleForceDeleteConfirm = async () => {
    setShowForceDeleteModal(false);
     try {
      await API.del('bridge', '/bridge?force=true', {
        body: {
          sourceCalendarId: item.sourceCalendarId,
          destCalendarId: item.destCalendarId,
        },
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'dashboardEvent',
        category: 'userActivity',
        action: 'deleteSync', // Consider different action label for force delete
        label: license.userId,
        email: license.email
      });
      window.location.reload(); // Consider updating state instead of reload if possible
    } catch (error) {
      console.error("Force delete failed:", error);
      alert("Failed to force delete sync."); // Simple error feedback
    }
  };

  // Functions to show modals by setting state
  function showDeleteConfirm() {
    setShowDeleteModal(true);
  }
  function showForceDeleteConfirm() {
    setShowForceDeleteModal(true);
  }
  const handleClick = ({ key }) => { // Destructure key from the argument object
    if (key === '0') {
      // showDisableConfirm()
      showForceDeleteConfirm()
    } else if (key === '1') {
      showDeleteConfirm()
    }
  }

  // Define menu items for CBDropdown
  const menuItems = (
    <CBMenu onClick={handleClick}>
       {item.status == 'delete_error' && (
          <CBMenuItem key="0" className="text-red-600" icon={<FontAwesomeIcon icon={faTrashAlt} />}>
            Force Delete
          </CBMenuItem>
        )}
        <CBMenuItem key="1" className="text-red-600" icon={<FontAwesomeIcon icon={faTrashAlt} />}>
          Delete
        </CBMenuItem>
    </CBMenu>
  );


  return (
    // Replaced Card with CBCard
    <div > {/* Use Tailwind classes */}
      {!preview && (
        // Replaced Dropdown with CBDropdown
        <CBDropdown overlay={menuItems} trigger={['click']} placement="bottomRight" className="absolute top-1 right-1 z-10">
            {/* Replaced Button with CBButton */}
            <CBButton type="ternary" className="p-1">...</CBButton> {/* Temporarily remove icon prop */}
        </CBDropdown>
      )}
      {/* Replaced Row with Flexbox */}
      <div className="flex items-center">
        {/* Replaced Col with div */}
        <div className=" pr-2"> {/* Approx span={8} */}
          {/* Replaced Title with h4 */}
          <h4 className="text-md font-semibold truncate">{item.sourceCalendarName}</h4>
           {/* Replaced Text with span/div and Tailwind */}
           <span className="text-sm text-gray-600 block break-all"> {/* Added block and break-all */}
            <div>{sourceAccountName}</div>
            {item.sourceCalendarAccountId}
            <FontAwesomeIcon
              icon={accountIconMap[item.sourceCalendarType].icon}
              className="mx-2 inline-block" // Replaced style with Tailwind
            />
          </span>
          {!preview && item.sourceColor != "same" && item.sourceColor != "default" && (<ColorPicker type={item.sourceCalendarType} color={item.sourceColor} preview={true}></ColorPicker>)}
        </div>
        
        {/* Replaced Col with div */}
        <div className=" px-2 text-center"> {/* Approx span={8}, added padding */}
          {item.twoWay  && <FontAwesomeIcon
            icon={faLongArrowAltLeft}
            size="3x" // Keep size prop
            className="text-green-500" // Use Tailwind color
          />}{' '}
          <FontAwesomeIcon
            icon={faLongArrowAltRight}
            size="3x" // Keep size prop
            className="text-green-500" // Use Tailwind color
          />
          {item.twoWay && <div><span className="text-xs text-gray-600">TWO WAY ROOT SYNC</span></div>} {/* Replaced Text */}
          {item.lastSyncTime < 0 && <div><span className="text-xs text-gray-600">TWO WAY LEG</span></div>} {/* Replaced Text */}
          <br />
          {/* Replaced Text with span */}
          <span className="text-xs text-gray-600 block"> {/* Added block */}
            {syncTypeText(
              !preview && item.securityPolicy.includes('subject'),
              !preview && item.securityPolicy.includes('description'),
              !preview && item.securityPolicy.includes('location'),
              !preview && item.securityPolicy.includes('reminder'),
              !preview && item.securityPolicy.includes('private'),
              !preview && item.securityPolicy.includes('meeting'),
              !preview && item.securityPolicy.includes('contact')
            )}
             {!preview && (<div><span className="text-xs text-gray-600"> {/* Replaced Text */}
          Tag: {item.tag != "default" ? item.tag : '(copy)'}</span></div>)}
            {!preview && item.status === 'synced' && 'Active and Up-to-Date'}
          </span>
        </div>
         
        {/* Replaced Col with div */}
        <div className="w-1/3 pl-2 text-center"> {/* Approx span={8}, added padding */}
          {/* Replaced Title with h4 */}
          <h4 className="text-md font-semibold truncate">{item.destCalendarName}</h4>
          {/* Replaced Text with span/div */}
         <span className="text-sm text-gray-600 block break-all"> {/* Added block and break-all */}
         <div>{destAccountName}</div>
            {item.destCalendarAccountId}
           
            <FontAwesomeIcon
              icon={accountIconMap[item.destCalendarType].icon}
              className="mx-2 inline-block" // Replaced style with Tailwind
            />
            {!preview && item.destinationColor != "default" && item.destinationColor != "same" && (<ColorPicker type={item.destCalendarType} color={item.destinationColor} preview={true}></ColorPicker>)}
     
            </span>
            
           </div>
        </div> {/* End of flex container (Replaced Row) */}

        
      {!preview && item.status !== 'synced' && item.status !== 'synced_renew' && (
        <>
          {/* Replaced Progress with CBProgress */}
          <div className="right-2 bottom-2 z-10"> {/* Simplified positioning */}
            <CBProgress
              type="circle"
              percent={Math.round((item.syncProgress / 12) * 100)}
              width={30} // Keep width
              strokeWidth={4} // Adjust strokeWidth if needed
              status={syncStatusMap[item.status]} // Pass status directly
              showInfo={false} // Hide percentage text
            />
          </div>
          {syncStatusMap[item.status] == "exception" && (
            <div className="right-12 bottom-1 z-10 text-xs text-red-600"> {/* Simplified positioning and styling */}
              {resolveError()}
            </div>
          )}
        </>
      )}
      

      {/* Delete Confirmation Modal */}
      <CBModal
        title="Delete Sync"
        visible={showDeleteModal}
        onPositiveClick={handleDeleteConfirm}
        onCancelClick={() => setShowDeleteModal(false)}
        positiveLabel="Delete"
        negativeLabel="Cancel"
        positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }}
      >
        <div className="flex items-center">
          <FontAwesomeIcon icon={faTrashAlt} className="text-red-600 text-xl mr-3" /> {/* Adjusted icon size */}
          <p>Are you sure you want to delete this sync?</p>
        </div>
      </CBModal>

      {/* Force Delete Confirmation Modal */}
      <CBModal
        title="Force Delete Sync"
        visible={showForceDeleteModal}
        onPositiveClick={handleForceDeleteConfirm}
        onCancelClick={() => setShowForceDeleteModal(false)}
        positiveLabel="Force Delete"
        negativeLabel="Cancel"
        positiveButtonProps={{ className: 'bg-red-600 hover:bg-red-700' }}
      >
         <div className="flex items-center">
          <FontAwesomeIcon icon={faTrashAlt} className="text-red-600 text-xl mr-3" /> {/* Adjusted icon size */}
          <p>Are you sure you want to force delete this sync? Copies will not be deleted!</p>
        </div>
      </CBModal>
    
      </div> // Replaced Card closing tag// Close the main fragment wrapping Card and Modals
  );
}

export default SyncItem;
